import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Invoice } from './invoice';
import { InvoiceItem } from './invoiceitem';
 import { environment } from '../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
	baseUrl = environment.baseUrl;
  private invoicesUrl = this.baseUrl +'/api/invoices';  // URL to web api
    private GetInvoicesDetailsURL = this.baseUrl +'/api/invoices/GetInvoicesDetails';
  private invoiceitemsUrl =this.baseUrl + '/api/invoiceitems';  // URL to web api
  private paidinvoicesUrl = this.baseUrl +'/api/invoices/getpaidinvoices';
  private unpaidinvoicesUrl = this.baseUrl +'/api/invoices/getunpaidinvoices';
  private dueinvoicesUrl = this.baseUrl +'/api/invoices/getdueinvoices';
  private overdueinvoicesUrl = this.baseUrl +'/api/invoices/getoverdueinvoices';
  private dashboardcountsUrl = this.baseUrl +'/api/invoices/getdashboardcounts';
   private GetRecentPaidInvoicesURL = this.baseUrl +'/api/invoices/GetRecentPaidInvoices';
   private GetAllRecentPaidInvoicesURL = this.baseUrl +'/api/invoices/GetAllRecentPaidInvoices';
   
   private GetDasboardgraphDataURL = this.baseUrl +'/api/invoices/GetDasboardgraphData';
   private invoicestatusUrl = this.baseUrl +'/api/invoices/UpdateInvoiceStatus';
   
  constructor( 
    private http: HttpClient
  ) { }
 
  getInvoices (): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(this.invoicesUrl)
  }
  
    GetPoCreatorInvoices (userid: number): Observable<Invoice[]> {
    const url = `${this.invoicesUrl}/GetPoCreatorInvoices/${userid}`;
    return this.http.get<Invoice[]>(url);
  } 
  getPaidInvoices (): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(this.paidinvoicesUrl)
  } 
    GetRecentPaidInvoices (): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(this.GetRecentPaidInvoicesURL)
  }
  GetAllRecentPaidInvoices (): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(this.GetAllRecentPaidInvoicesURL)
  }  
  
     GetDasboardgraphData (): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(this.GetDasboardgraphDataURL)
  } 
  getUnpaidInvoices (): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(this.unpaidinvoicesUrl)
  } 
  getDueInvoices (): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(this.dueinvoicesUrl)
  } 
  getOverDueInvoices (): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(this.overdueinvoicesUrl)
  } 
  getDashboardCountsFinance (): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(this.dashboardcountsUrl)
  } 
  getInoviceById (invoiceid: number): Observable<Invoice[]> {
    const url = `${this.invoicesUrl}/${invoiceid}`;
    return this.http.get<Invoice[]>(url);
  } 

  updatePaymentStatus(invoiceid: number): Observable<Invoice> {
    const url = `${this.invoicestatusUrl}/${invoiceid}`;
    return this.http.get<Invoice>(url);
  } 
  

  getInvoice(invoiceid: number): Observable<Invoice> {
    const url = `${this.invoicesUrl}/${invoiceid}`;
    return this.http.get<Invoice>(url);
  }
 
  GetInvoicesDetail(invoiceid: number): Observable<Invoice> {
    const url = `${this.GetInvoicesDetailsURL}/${invoiceid}`;
    return this.http.get<Invoice>(url);
  }
 
  addInvoice (invoice: Invoice): Observable<Invoice> {
    return this.http.post<Invoice>(this.invoicesUrl, invoice, httpOptions);
  }
  addInvoiceitem (invoiceitem: InvoiceItem): Observable<Invoice> {
    return this.http.post<Invoice>(this.invoiceitemsUrl, invoiceitem, httpOptions);
  }
  
   updateInvoiceitem (invoiceitem: InvoiceItem): Observable<any> {
    return this.http.put(this.invoiceitemsUrl, invoiceitem, httpOptions);
  }
  
   deleteInvoiceItem (invoiceitemid: number | number): Observable<InvoiceItem> {
   // const id = typeof invoice === 'number' ? invoice : invoice.invoiceid;
    const url = `${this.invoiceitemsUrl}/${invoiceitemid}`;
 
    return this.http.delete<InvoiceItem>(url, httpOptions);
  }
 
  deleteInvoice (invoice: Invoice | number): Observable<Invoice> {
    const id = typeof invoice === 'number' ? invoice : invoice.invoiceid;
    const url = `${this.invoicesUrl}/${id}`;
 
    return this.http.delete<Invoice>(url, httpOptions);
  }
 
  updateInvoice (invoice: Invoice): Observable<any> {
    return this.http.put(this.invoicesUrl, invoice, httpOptions);
  }
}